import styled from "styled-components";
import { Link } from "react-router-dom";

const Enlace = styled(Link)`
  text-decoration: none;
  z-index: 2;
`;

const Frecuentes = ({ imagen }) => {

    const { path } = imagen;
    return (
        <Enlace className="enlaces" to="preguntas">
            <img src={path} alt="icono" />
            Preguntas Frecuentes
        </Enlace>
    )
}

export default Frecuentes